export default __webpack_public_path__ + "static/media/illustration-logo.98cf606e.png";